module.exports = "/static/Images/pt-br/Zero.png";